//平台内置弹框内的组件
const DesDataGridExpColChoose = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_sys_modal" */ "./dataGridExpColChoose"));
const DesCommonImportErrorDataEidt = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_sys_modal" */ "./commonImportErrorDataEidt"));
const DsfExportSetting = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_sys_modal" */ "./exportSetting"));
const DsfCatalogueOptions = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_sys_modal" */ "./catalogue"));
const DsfPlatformSlideVerify = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_sys_modal" */ "./verify/slide.vue"));
const DsfPlatformSelectVerify = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_sys_modal" */ "./verify/select.vue"));
const DsfPlatformNineGridVerify = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_sys_modal" */ "./verify/nineGrid.vue"));
const DsfMenuOptions = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_sys_modal" */ "./menu/menuOptions"));

function install(Vue) {
  Vue.component("DesDataGridExpColChoose", DesDataGridExpColChoose);
  Vue.component("DesCommonImportErrorDataEidt", DesCommonImportErrorDataEidt);
  Vue.component("DsfExportSetting", DsfExportSetting);
  Vue.component("DsfCatalogueOptions", DsfCatalogueOptions);
  Vue.component("DsfPlatformSlideVerify", DsfPlatformSlideVerify);
  Vue.component("DsfPlatformSelectVerify", DsfPlatformSelectVerify);
  Vue.component("DsfPlatformNineGridVerify", DsfPlatformNineGridVerify);
  Vue.component("DsfMenuOptions", DsfMenuOptions);
}
export default install;
